// import { APP_CONFIG_FILE_VARIABLE_NAME } from '../../build/constants'

export const getEnvConfig = () => {
  // const envName = APP_CONFIG_FILE_VARIABLE_NAME.toUpperCase()
  // const ENV = (import.meta.env.DEV ? import.meta.env : window[envName]) as ViteGlobEnv
  const ENV = import.meta.env as ViteGlobEnv

  const {
    VITE_GLOB_API_URL,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_IMAGE_URL,
    VITE_PDA_URL,
    VITE_GLOB_SENTRY_DSN,
    VITE_ENABLE_SENTRY,
  } = ENV
  return {
    VITE_GLOB_API_URL,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_IMAGE_URL,
    VITE_PDA_URL,
    VITE_GLOB_SENTRY_DSN,
    VITE_ENABLE_SENTRY,
  }
}
